<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 7C9 6.58579 9.33579 6.25 9.75 6.25H16.25C16.6642 6.25 17 6.58579 17 7C17 7.41421 16.6642 7.75 16.25 7.75H9.75C9.33579 7.75 9 7.41421 9 7Z"
      fill="currentColor"
    />
    <path
      d="M9 13C9 12.5858 9.33579 12.25 9.75 12.25H16.25C16.6642 12.25 17 12.5858 17 13C17 13.4142 16.6642 13.75 16.25 13.75H9.75C9.33579 13.75 9 13.4142 9 13Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 7C4 7.55228 4.44772 8 5 8C5.55228 8 6 7.55228 6 7C6 6.44772 5.55228 6 5 6C4.44772 6 4 6.44772 4 7ZM5 5C3.89543 5 3 5.89543 3 7C3 8.10457 3.89543 9 5 9C6.10457 9 7 8.10457 7 7C7 5.89543 6.10457 5 5 5Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 13C4 13.5523 4.44772 14 5 14C5.55228 14 6 13.5523 6 13C6 12.4477 5.55228 12 5 12C4.44772 12 4 12.4477 4 13ZM5 11C3.89543 11 3 11.8954 3 13C3 14.1046 3.89543 15 5 15C6.10457 15 7 14.1046 7 13C7 11.8954 6.10457 11 5 11Z"
      fill="currentColor"
    />
  </svg>
</template>
